<div class="">
  <div class="basicrow-special">
    <div class="container">
      <div class="">
        <div class="basicrow text-center">
          <div class="rdtitles">
            <div class="info-texto">
              El cambio fue <span class="roboto-b">exitoso</span>
            </div>
          </div>
        </div>
      </div>
      <div class="notopbrd">
        <div class="basicrow tabtopb f-black roboto-r f-reg">
          <div class="basicrow">
            <div class="details-box">
              <div class="userinfo full nomtops mb-4">
                <div class="basicrow m-bott">
                  <div class="basicrow f-bmed roboto-b m-bott">
                    Resumen de Cambio
                  </div>
                  <div class="redstat" *ngIf="this.nroOrder==true">
                    <div class="autorow roboto-r pull-left">
                      N&uacute;mero de Orden
                    </div>
                    <div class="autorow roboto-b pull-right">
                      {{this.numberOrder}}
                    </div>
                  </div>
                  <div class="redstat">
                    <div class="basicrow">
                      Nuevo Plan
                    </div>
                    <div class="basicrow roboto-b m-top-u-i" style="line-height: 1.5;">
                      {{this.planToChange}} :
                      <span *ngFor="let description of this.descriptions; let n = index">
                          {{description.description}}
                        </span>
                    </div>
                  </div>
                </div>
                <div class="basicrow text-center">
                  <div class="basicrow">
                      <span class="roboto-b">
                        Precio
                      </span><br>
                    <span class="f-red f-semi roboto-m">
                        {{this.pricePlan|currency}}
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="basicrow text-center m-top pt-4">
            <a (click)="close()" class="btns def-i gray centr vcenter">
              <span class="tabcell">
                Cerrar
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
